import { useModal } from '@shared/model/useModal';

export const useAddTeacherReviewModal = () => useModal('add-teacher-review')